/*
 * Project: xpenser-client
 * FilePath: /src/app/hooks/authentication/index.tsx
 * File: index.tsx
 * Created Date: Friday, September 18th 2020, 12:32:39 pm
 * Author: Craig Bojko (craig@pixelventures.co.uk)
 * -----
 * Last Modified: Fri Sep 18 2020
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2020 Pixel Ventures Ltd.
 * ------------------------------------
 * <<licensetext>>
 */

import { useState, useCallback, useEffect } from 'react'
import axios from 'axios'

import { getCookie } from '../../common/helpers/cookie'

// Authentication hook - essentially sets up the context when used as value for AuthContext.Provider
export const useAuthentication = (url: string) => { // returns Context
  const [ jwt, setJWT ] = useState<string | null>(getCookie('jwt'))
  const [ isAuthenticated, setAuth ] = useState<boolean | null>(null)

  const setAuthentication = useCallback((authState: boolean) => setAuth(authState), [])
  const setIdToken = useCallback((jwt: string) => setJWT(jwt), [])
  
  useEffect(() => {
    const verify = async () => {
      try {
        await axios({
          url,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          data: { token: jwt }
        })
        setAuth(true)
      } catch (e) {
        setAuth(false)
      }
    }
    if (jwt) {
      verify()
    } else {
      setAuth(false)
    }
  }, [ jwt, url ])

  return {
    isAuthenticated,
    setAuthentication,
    setIdToken
  }
}

export default useAuthentication
